var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 0.400024C4.69699 0.400024 0.398987 4.69802 0.398987 10C0.398856 11.2609 0.647103 12.5094 1.12955 13.6743C1.612 14.8392 2.3192 15.8977 3.21076 16.7892C4.10232 17.6808 5.16078 18.388 6.32569 18.8705C7.49059 19.3529 8.73913 19.6012 9.99999 19.601C15.301 19.601 19.6 15.303 19.6 10C19.6 4.69802 15.301 0.400024 9.99999 0.400024ZM10.896 3.86602C11.832 3.86602 12.107 4.40902 12.107 5.03002C12.107 5.80502 11.487 6.52202 10.428 6.52202C9.54199 6.52202 9.11999 6.07702 9.14599 5.34002C9.14599 4.71902 9.66499 3.86602 10.896 3.86602ZM8.49799 15.75C7.85799 15.75 7.39099 15.361 7.83799 13.656L8.57099 10.631C8.69799 10.147 8.71899 9.95302 8.57099 9.95302C8.37999 9.95302 7.54899 10.287 7.05899 10.617L6.73999 10.094C8.29499 8.79502 10.083 8.03302 10.848 8.03302C11.488 8.03302 11.594 8.78902 11.275 9.95302L10.435 13.133C10.286 13.695 10.35 13.889 10.499 13.889C10.691 13.889 11.319 13.657 11.937 13.17L12.299 13.656C10.786 15.168 9.13699 15.75 8.49799 15.75Z",
    fill: "#0047AB",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.66892ad5ef66ca3b787fbeea672ecae9.svg";
export { ForwardRef as ReactComponent };